// extracted by mini-css-extract-plugin
export default {"backdrop":"loader_backdrop__4Qr+S","loader":"loader_loader__27bcz"};